import type { State } from "../store/state";
import type { Store } from "vuex";
import type { SearchState, SetDefaultDateFieldPayload } from "../model/searchState";
import type { MetaDataSchema } from "@mimir/common/mdf/metadataSchema";
import { type DefaultDateRangeFieldChoice, getDefaultDateRangeFieldChoices, mediaCreatedDateRangeField } from "../pages/search/util";
import { findDateFilterChoiceForField } from '@mimir/web/util/findDataFilterChoiceForField';


// TODO: The reason this has to live outside of SearchState is that SearchState
// does not own the filters for some reason. If the filters also resided inside
// the SearchState we could reduce the SearchState API surface substantially.
export function setDefaultDateRangeField(
  store: Store<State>,
  searchState: SearchState,
  payload: SetDefaultDateFieldPayload | undefined
): void {
  if (!payload) {
    store.commit('setDateFilterField', payload);
    return;
  }

  const mdfs: MetaDataSchema[] = store.getters.mdfs;
  let dateFilterFieldChoice: DefaultDateRangeFieldChoice = mediaCreatedDateRangeField;
  if (payload.fieldIdOrGuid) {
    const defaultDateRangeFieldChoices = getDefaultDateRangeFieldChoices(store.getters.mdfs);
    const match = findDateFilterChoiceForField(defaultDateRangeFieldChoices, payload, mdfs);
    if (match) dateFilterFieldChoice = match;
  }

  searchState.ops.setDefaultDateRangeField({
    fieldIdOrGuid: dateFilterFieldChoice.value,
    formId: dateFilterFieldChoice.customMdf?.id,
  });

  store.commit(
    'setDateFilterField',
    {
      key: dateFilterFieldChoice.value,
      label: dateFilterFieldChoice.label,
      mdf: dateFilterFieldChoice.customMdf
    }
  );
}
